import EventDescription from "./EventDescription";
export default EventDescription;
